import commonMixin from "@/components/common/mini-table/mixins/common-mixin";
import _ from 'lodash'

export default {
    mixins: [commonMixin],
    props: {
        sortQuery: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            sortBy: null,
            sortDesc: false,
        }
    },
    computed: {
        isSorting() {
            return this.hasCode(this.sortBy);
        },
    },
    methods: {
        setSorting({key, desc}) {
            if (this.isSorting && this.sortBy === key && this.sortDesc === desc) {
                this.clearSort();
            } else {
                this.sortBy = key;
                this.sortDesc = desc;
            }
            if (this.sortQuery) {
                this.emitSort();
            }
        },
        sortRows(event) {
            if (event) {
                this.sortBy = event.sortBy;
                this.sortDesc = event.sortDesc;
                if (this.sortQuery) {
                    this.emitSort();
                }
            }
        },
        clearIfSort(key) {
            if (this.sortBy === key) {
                this.clearSort();
            }
        },
        clearSort() {
            this.sortBy = null;
            this.sortDesc = false;
        },
        getSortResult(list) {
            return _.orderBy(list, [this.sortBy],
                [this.sortDesc ? 'desc' : 'asc'])
        },
        doSort(list) {
            if (this.isSorting && !this.sortQuery) {
                return this.getSortResult(list);
            } else {
                return list;
            }
        },
        emitSort() {
            this.$emit('sortChange', {
                field: this.sortBy,
                direction: this.sortDesc ? 'DESC' : 'ASC'
            });
        },
    },
}
